module.exports = __webpack_public_path__ + "static/media/vision.23bd738c.png";